import {
  ListButton,
  LoadMoreButton,
  NewsCard,
  NewsServiceName,
  SiteConfig
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { Props as CardActionCheckboxProps } from "components/Cards/Card/Actions/Checkbox"
import { memo } from "react"

import Main from "./Main"

export interface AddNewsActionCheckboxes {
  onlyNewProps: CardActionCheckboxProps
  onlyPresentProps: CardActionCheckboxProps
  showFlaggedProps: CardActionCheckboxProps
}

interface Props {
  actionCheckboxes: Record<NewsServiceName, AddNewsActionCheckboxes>
  clearAllListsButtonProps: ListButton
  clearListButtonProps: Record<NewsServiceName, ListButton>
  isAdmin: boolean
  isEditor: boolean
  listAllButtonProps: ListButton
  listButtonProps: Record<NewsServiceName, ListButton>
  loadMoreButtonProps: Record<NewsServiceName, LoadMoreButton>
  newsCards: Record<NewsServiceName, NewsCard>
  siteConfigNews: SiteConfig["news"]
}

export interface ComponentProps extends Props {}

export default memo(Main)
